import React, { useState } from 'react';
import { Alert, InputGroup, InputGroupAddon, InputGroupText, UncontrolledTooltip, FormFeedback, Spinner, Form, FormGroup, Label, Row, Col, Input, Button, Card, CardHeader, CardBody, CardTitle, CardText } from 'reactstrap';
import IngresaCuenta from '~/components/IngresaCuenta';
import FormularioSuscripcion from '~/components/FormularioSuscripcion';
import { withRouter } from 'react-router';
import API from '~/API';

const SuscripcionPAC = (props) => {
    const [step, setStep] = useState(1);
    const [mensajes, setMensajes] = useState([]);
    const [cargando, setCargando] = useState(false);
    const [textoCargando, setTextoCargando] = useState('');
    const [suscripcionInfo, setSuscripcionInfo] = useState(null);
    const [montoMaximo, setMontoMaximo] = useState(null);

    const handleSuscripcionSubmit = () => {
        setTextoCargando('Redirigiendo al portal de pago...');
        setCargando(true);
    };

    const handleIdentificacionSubmit = async ({ tipo, payload }) => {
        setTextoCargando('Buscando su servicio...');
        setCargando(true);
        setMensajes([]);

        try {
            let info;
            if (tipo === 'servicio') {
                // Transform payload for the API: servicio -> id_servicio
                const apiPayload = { ...payload, id_servicio: payload.servicio };
                delete apiPayload.servicio;
                info = await API.Call(`Consulta/${payload.empresa}/Suscripcion/Info`, apiPayload);

            } else if (tipo === 'direccion') {
                // Transform payload for the API: address parts and captcha to PascalCase
                const direccionPayload = {
                    empresa: payload.empresa,
                    Comuna: payload.comuna,
                    Calle: payload.calle,
                    NoCasa: payload.noCasa,
                    NoDpto: payload.noDpto,
                    Captcha: payload.captcha
                };

                const direccionInfo = await API.Call(`Consulta/${payload.empresa}/Servicio/Direccion`, direccionPayload);
                // The captcha key for the second call (Suscripcion/Info) is correct as lowercase
                info = await API.Call(`Consulta/${payload.empresa}/Suscripcion/Info`, { servicioFalso: direccionInfo.servicioFalso, captcha: payload.captcha });
            }

            if (info && info.habilitado) {
                setSuscripcionInfo(info);
                setMontoMaximo(info.montoMaximo);
                setStep(2);
            } else {
                setMensajes([{ tipo: "warning", texto: "La suscripción de pago automático no está habilitada para esta empresa o servicio." }]);
            }
        } catch (error) {
            setMensajes([{ tipo: "danger", texto: error.toString() }]);
        }
        setCargando(false);
    };

    const renderStep1 = () => (
        <>
            <div className="intro-text">
                <CardTitle tag="h5">Suscribir Pago Automático de Cuentas (PAC)</CardTitle>
                <CardText>Ingrese los datos de su cuenta para comenzar el proceso de suscripción.</CardText>
            </div>
            <IngresaCuenta {...props} onConsultar={handleIdentificacionSubmit} />
        </>
    );

    const renderStep2 = () => {
        const recaudadores = Object.keys(suscripcionInfo.recaudadores || {});
        
        return (
            <>
                <div className="intro-text">
                    <CardTitle tag="h5">Suscribir Pago Automático</CardTitle>
                    <CardText>
                        {suscripcionInfo.servicio.id_servicio 
                            ? <>Servicio: {suscripcionInfo.servicio.id_servicio}<br /></> 
                            : null
                        } 
                        Dirección: {suscripcionInfo.servicio.dir_instal}, {suscripcionInfo.servicio.comuna_instal}
                    </CardText>
                </div>
                <hr/>
                <h6 className="form-step-title">Paso 2: Elija su medio de pago y complete sus datos</h6>
                <FormularioSuscripcion 
                    isAnonimo={true}
                    montoMaximo={montoMaximo}
                    recaudadores={recaudadores}
                    servicio={suscripcionInfo.servicio}
                    servicioFalso={suscripcionInfo.servicio.servicioFalso}
                    empresa={suscripcionInfo.servicio.empresa}
                    empresaNombre={suscripcionInfo.servicio.empresa}
                    onLoading={handleSuscripcionSubmit}
                    onVolver={() => { setStep(1); setSuscripcionInfo(null); }}
                />
            </>
        );
    };

    return (
        <Card className="panel-ingreso-lectura">
            <CardHeader className="titulo-modal">Suscripción de Pago Automático</CardHeader>
            <CardBody className="cuerpo-modal">
                <Row>
                    <Col sm="12" md={{ size: 8, offset: 2 }} lg={{ size: 6, offset: 3 }} className="bordeCompleto">
                        {cargando && <div className="text-center p-5"><Spinner style={{ width: '3rem', height: '3rem' }} /><h4>{textoCargando}</h4></div>}
                        <div style={{ display: cargando ? 'none' : 'block' }}>
                            {mensajes.length > 0 && (
                                <div className="mt-4">
                                    {mensajes.map((m, i) => <Alert key={i} color={m.tipo} className="text-center">{m.texto}</Alert>)}
                                </div>
                            )}
                            {step === 1 ? renderStep1() : renderStep2()}
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
};

export default withRouter(SuscripcionPAC);